import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getUserMissionDetailsAction = createAsyncThunk(
    'get-user-mission-details',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/get-user-mission-details?mission_id=${data}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getUserMissionDetailsSlice = createSlice({
    name: 'get-user-mission-details',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getUserMissionDetailsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getUserMissionDetailsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getUserMissionDetailsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getUserMissionDetailsReducer = getUserMissionDetailsSlice.reducer    